import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpJobOrderHdrContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-job-order-hdr-container.model';
import { MrpJobOrderItemStockContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-job-order-item-stock-container.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { JobStockItemAvailabilityContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/job-stock-item-availability-container.model';
import { Pagination } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class MrpJobOrderHdrService extends BaseApiTemplateService<MrpJobOrderHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders/backoffice-ep"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders/backoffice-ep"
    this.httpClient = http;
  }

  verifyJobOrderNumber(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders/verify-job-order-no/backoffice-ep";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  checkItemAvailability(invItemGuid: string, locationGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders/check-item-availability/backoffice-ep";
    }
    const UrlByCriteria = `${this.apiUrl}?inv_item_guid=${invItemGuid}&location_guid=${locationGuid}`;
    return this.httpClient.get<BasicApiResponseModel<JobStockItemAvailabilityContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  getJobOrdersWithItemStockByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders/job-order-with-item-stock/backoffice-ep";
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MrpJobOrderItemStockContainerModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

}
